
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/legal-judicial-advocacy/amicus",
      function () {
        return require("private-next-pages/advocacy/legal-judicial-advocacy/amicus/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/legal-judicial-advocacy/amicus"])
      });
    }
  